import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { logout } from "../../features/auth";
import { IMapFilters } from "../../models/storeModels/IMapFilters";
import { getItemWebStorage } from "../../features/webStorageSaver";

function getInitialState(){
    const initialState: IMapFilters = {
        lastYearsMapFilters: getItemWebStorage('lastYearsMapFilters')
    }
    return initialState
} 

export const mapFiltersSlice = createSlice({
    name: 'mapFilters',
    initialState: getInitialState(),
    reducers: {
        setLastYearsMapFilters(state, action: PayloadAction<any>) {
            state.lastYearsMapFilters = action.payload
        },
    },
    extraReducers: (builder) => {
        builder.addCase(logout, () => {
            return getInitialState()
        })
    },
})

export const { setLastYearsMapFilters } = mapFiltersSlice.actions
export const mapFiltersReducer = mapFiltersSlice.reducer;
